// Copyright (c) 2022 by Move Closer.

import { AnyObject, MappingConfig, MappingTypes } from '@movecloser/front-core'

import { AddressData } from '../../../contexts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl> (edited)
 */
export const userAdapterMap: MappingConfig = {
  email: 'email',
  firstName: 'firstname',
  lastName: 'lastname',
  dateOfBirth: 'date_of_birth',
  isAdmin: 'is_admin',
  isB2B: {
    type: MappingTypes.Function,
    value: (item) => {
      if (!Array.isArray(item.addresses) || item.addresses.length === 0) {
        return false
      }

      return !!item.addresses.find((address: AnyObject) => !!address.vat_id)
    }
  },
  isPremium: {
    type: MappingTypes.Function,
    value: (item) => !!item.friends_and_family
  },
  isB2BRequested: 'is_b2b_requested',
  isExistingCompanyRequested: 'is_existing_company_requested',
  isSubscribed: 'is_subscribed',
  isVerified: 'is_verified',
  addresses: {
    type: MappingTypes.Function,
    value: (item) => {
      if (!Array.isArray(item.addresses) || item.addresses.length === 0) {
        return []
      }

      const addressesArray: Array<AddressData> = []
      item.addresses.forEach((address: AnyObject) => {
        addressesArray.push({
          id: address.id,
          company: address.company,
          countryCode: address.country_code,
          city: address.city,
          defaultBilling: address.default_billing,
          defaultShipping: address.default_shipping,
          firstName: address.firstname,
          lastName: address.lastname,
          phoneNumber: address.telephone,
          street: address.street[0],
          postalCode: address.postcode,
          region: {
            name: address.region.region,
            code: address.region.region_code,
            id: address.region.region_id
          },
          vatId: address.vat_id
        })
      })
      return addressesArray
    }
  }
}
